import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'

const getWaterInfoMarkdown = (state: RootState) => state.waterInfo.markdown
const getSelectedWaterParameter = (state: RootState) => state.waterInfo.selectedWaterParameter
const getIsOpen = (state: RootState) => state.waterInfo.open
const makeWaterInfoMarkdownByName = createSelector(
  [getWaterInfoMarkdown, getSelectedWaterParameter],
  (markdown, name) => {
    const v = name.toLowerCase()
    return (markdown[v] && markdown[v].join('\n')) || ''
  },
)

export const WaterInfoSelectors = {
  getWaterInfoMarkdown,
  getSelectedWaterParameter,
  getIsOpen,
  makeWaterInfoMarkdownByName,
}
